/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShopifyPairingClaimedByView } from './ShopifyPairingClaimedByView';
/**
 * Shopify pairing status
 */
export type ShopifyPairingStatusView = {
    /**
     * Pairing status
     */
    status: ShopifyPairingStatusView.status;
    /**
     * Claimed by user (when status is claimed)
     */
    claimed_by?: ShopifyPairingClaimedByView | null;
};
export namespace ShopifyPairingStatusView {
    /**
     * Pairing status
     */
    export enum status {
        WAITING = 'waiting',
        CLAIMED = 'claimed',
        EXPIRED = 'expired',
        NOT_FOUND = 'not_found',
    }
}

